module.exports = __webpack_public_path__ + "static/media/arrow-up.3981dcbd.svg";